import React, {useRef, useState} from "react";
import styles from "./page.module.scss";
import {ReactComponent as UploadIcon} from "../../../../assets/flyersScreen/upload_icon.svg";
import {ReactComponent as MenuOnHover} from "../../../../assets/promos&items/menu_on_hover.svg";

import {ReactComponent as UnlinkedIcon} from "../../../../assets/editors/unlinked_page.svg";
import {ReactComponent as ApprovePage} from "../../../../assets/pages/approved_page.svg";
import {ReactComponent as NotApprovePage} from "../../../../assets/pages/not_approved_page.svg";
import {ReactComponent as ApprovePageForSystem} from "../../../../assets/pages/approved_page_system.svg";
import {DefaultSizesDto, FlyerPageDto, ItemsListMenuDto, UserDto} from "../../../../dtos";
import {OptionsForSelectPages} from "./optionsSelectForMove/optionsSelectForMove";
import LabelFileSelector from "../../../../com/labelFileSelector/LabelFileSelector";
import {PagesDataStateDto} from "../pages";
import {
    changeQualificationStatusForPage,
} from "../../../../store/actionCreators/pagesActionCreators";
import {useDispatch} from "react-redux";
import {AsyncPageImage} from "./image/image";
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {Box, Button, Grid} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
    MenuForPromotion
} from "../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";

const useStyles = makeStyles(() => ({
    qualificationIconWrapper: (props: any) => ({
        display: `flex`,
        width: `22px`,
        height: `22px!important`,
        position: `absolute`,
        right: `3px`,
        top: `3px`,
        cursor: props.isNotQualified ? `default!important` : `cursor`,
        zIndex: 1
    }),
    flyerBoxWrapper: {
        height: "264px",
        cursor: "pointer",
    },
}))

interface InsertData {
    flyerRecID: number;
    pageNo: number;
    uiLanguageCultureCode: string;
}

type DataForRow = {
    dataKey: FlyerPageDto;
    deleteImagesFromPages?: any;
    deletePages?: any;
    insertPageCallback: (data: InsertData) => void;
    movePageCallback: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    isActivePage?: boolean;
    isLastActivePage: boolean;
    onAddImageToPageFile?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    pagesDataState: PagesDataStateDto
    setPagesDataState: (e: PagesDataStateDto) => void;
    columnNumbersWidth: number;
    setActivePages: (pages: FlyerPageDto[], page: FlyerPageDto | null, isSelectAll: boolean, pageNumberForTab: number | null) => void;
}

export const Page = (props: DataForRow) => {
    const dispatch = useDispatch();

    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const promotionsItemsState = useTypedSelector((state) => state.promotionsAndItems);
    const [isOpenedPageMenu, setOpenPageMenu] = useState(false);
    const anchorRefForPageMenu = useRef(null);
    const prevOpenPageMenu = useRef(isOpenedPageMenu);
    let userDtoStr = localStorage.getItem('userDto');
    // const isUserViewer = false;
    let isUserViewer = true;
    let isUserEditor = false;
    if(userDtoStr){
        let userDto: UserDto = JSON.parse(userDtoStr);
        isUserViewer = userDto.role !== 2 && userDto.role !== 3;
        isUserEditor = userDto.role === 2;
    }

    const properties = {
        isNotQualified: props.dataKey.qualificationLevel === 0,
    }
    const classes = useStyles(properties);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onAddImageToPageFile!(e);
    }

    const onChangeOnlyOne = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onAddImageToPageFile!(e);
    }

    const onClick = () => {
        props.setPagesDataState({
            ...props.pagesDataState,
            selectedPages: [props.dataKey].sort(compare)
        });
    }

    const compare = (a: any, b: any) => {
        if (a.flpPageNo < b.flpPageNo) {
            return -1;
        }
        if (a.flpPageNo > b.flpPageNo) {
            return 1;
        }
        return 0;
    }

    const setAlwaysActivePage = (isDoubleClick: boolean) => {
        const isExist = props.pagesDataState.selectedPages.some((page: any) => props.dataKey.flpPageNo === page.flpPageNo)

        props.setPagesDataState({
            ...props.pagesDataState,
            selectedPages: isExist ? [...props.pagesDataState.selectedPages].sort(compare) : [props.dataKey],
            lastSelectedPage: [props.dataKey],
            isDoubleClick: isDoubleClick
        })
    };

    const setActivePageStatus = (e: React.MouseEvent<HTMLElement>) => {
        const target = e.target as HTMLElement;
        const tagName = target.tagName;
        const isCtrlKey = e.ctrlKey || e.metaKey;
        const isShiftKey = e.shiftKey;
        const lastSelectedPageLength = props.pagesDataState.lastSelectedPage.length;
        e.stopPropagation();
        if (tagName !== "BUTTON" && tagName !== "LABEL" && tagName !== "SELECT" && tagName !== "INPUT" && tagName) {
            if (isCtrlKey || isShiftKey && lastSelectedPageLength) {
                if (isCtrlKey) {
                    if (!props.isActivePage) {
                        const newArr = [...props.pagesDataState.selectedPages, props.dataKey].sort(compare);
                        props.setActivePages(
                            newArr,
                            props.dataKey,
                            newArr.length === props.pagesDataState.pagesFlyer.length,
                            props.dataKey.flpPageNo || 0
                        );
                    } else {
                        const newArr = props.pagesDataState.selectedPages.filter((page: any) => page.flpGuid !== props.dataKey.flpGuid).sort(compare);
                        let selectedPagesAfterDeselected = [...newArr];
                        props.setActivePages(
                            newArr.length ? newArr : [],
                            props.dataKey,
                            newArr.length === props.pagesDataState.pagesFlyer.length,
                            selectedPagesAfterDeselected.length ? selectedPagesAfterDeselected[0].flpPageNo || 0 : 0
                        );
                    }
                } else {
                    const pagesData = props.pagesDataState.pagesFlyer;
                    const lowerFlpPageNo = Math.min(props.dataKey.flpPageNo!, props.pagesDataState.lastSelectedPage[0].flpPageNo!);
                    const upperFlpPageNo = Math.max(props.dataKey.flpPageNo!, props.pagesDataState.lastSelectedPage[0].flpPageNo!);
                    const newArr = pagesData.filter((page: any) => page.flpPageNo >= lowerFlpPageNo && page.flpPageNo <= upperFlpPageNo).sort(compare);
                    props.setActivePages(
                        newArr.length ? newArr : [],
                        null,
                        newArr.length === pagesData.length,
                        null
                    );
                }
            } else {
                const {setActivePages, dataKey} = props;
                setActivePages([dataKey], dataKey, false, dataKey.flpPageNo || 0);
            }
        }
    }

    const insertBeforePageCallback = () => {
        const minPage = Math.min(...props.pagesDataState.selectedPages.map((item: any) => item.flpPageNo));
        props.insertPageCallback({
            flyerRecID: props.dataKey.flpFlyRecId!,
            pageNo: minPage === 1 ? 1 : minPage,
            uiLanguageCultureCode: 'en-US'
        })
    }

    const insertAfterPageCallback = () => {
        const maxPage = Math.max(...props.pagesDataState.selectedPages.map((item: any) => item.flpPageNo));
        props.insertPageCallback({
            flyerRecID: props.dataKey.flpFlyRecId!,
            pageNo: maxPage + 1,
            uiLanguageCultureCode: 'en-US'
        })
    }

    const optionForSelectPages = props.pagesDataState.pagesFlyer.map((key: FlyerPageDto) => {
        return <OptionsForSelectPages key={key.flpRecId} value={key.flpPageNo || -1}
                                      currentPage={props.dataKey}/>
    });

    const isPageHasContent = props.dataKey.flyerPageSpots!.length > 0;

    const isDisabledContextMenuOption = props.pagesDataState.selectedPages.length > 1 && true || flyerDetailsState.flyFstRec.fstCaption === "Published";
    const isShowInfoForPage = props.pagesDataState.selectedPages.length === 1;
    const pageWxH: DefaultSizesDto = {
        width: props.dataKey.flpWidthPx || 0,
        height: props.dataKey.flpHeightPx || 0,
    }
    let timer: any = 0;
    const delay = 100;
    let prevent = false;

    const doClickAction = (e: React.MouseEvent<HTMLElement>) => {
        setActivePageStatus(e);
    }

    const doDoubleClickAction = () => {
        setAlwaysActivePage(true);
    }

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        setOpenPageMenu(false);
        clearTimeout(timer);
        timer = setTimeout(() => {
            if (!prevent) {
                doClickAction(e);
            }
            prevent = false;
        }, delay);
    }

    const handleDoubleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        clearTimeout(timer);
        prevent = true;
        doDoubleClickAction();
    }

    const onChangeQualificationLVL = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        const {dataKey} = props;

        if (dataKey.qualificationLevel === 0) {
            return;
        }

        const pagesIds: number[] = [dataKey.flpRecId!]
        // const pagesIds: number[] = isActivePage
        //     ? pagesDataState.selectedPages
        //         .filter((page: FlyerPageDto) => page.qualificationLevel !== 0)
        //         .map((page: FlyerPageDto) => page.flpRecId!)
        //     : [dataKey.flpRecId!];

        dispatch(changeQualificationStatusForPage(
            pagesIds,
            flyerDetailsState?.flyLacRec?.lacCode!,
            dataKey.qualificationLevel === 1 ? 2 : 1,
            flyerDetailsState,
        ));
    };
    const handleToggleForPage = () => {
        setOpenPageMenu((prevOpen) => !prevOpen);
    };


    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenPageMenu,
        prevOpen: prevOpenPageMenu,
        open: isOpenedPageMenu,
        anchorRef: anchorRefForPageMenu,
    };

    return (
        <Grid item xs={props.columnNumbersWidth}
              id={`page${props.dataKey.flpRecId}`}
              className={`${classes.flyerBoxWrapper}`}
        >
            <div
                className={`${props.isActivePage ? styles.page_active : ''} ${props.isLastActivePage ? 'last_active_page' : ''} ${styles.page}`}>
                {isPageHasContent && <div
                    className={`${styles.linked_page} ${flyerDetailsState.flyFstRec.fstCaption === "Published" ? styles.disabled : ''}`}>
                    <UnlinkedIcon title={`Page with linked frames`}/>
                </div>}
                {promotionsItemsState.isQualified && (
                    <Button className={classes.qualificationIconWrapper}
                            onClick={onChangeQualificationLVL}
                            disabled={isUserViewer || isUserEditor}
                            sx={{
                                position: `absolute`,
                                "&:disabled": {
                                    opacity: "0.5"
                                }
                            }}
                    >
                        {props.dataKey.qualificationLevel === 0 &&
                            <NotApprovePage title="Page Unqualified. Check Promos & Items"/>}
                        {props.dataKey.qualificationLevel === 1 &&
                            <ApprovePageForSystem title="Page Qualified. Click to Approve."/>}
                        {props.dataKey.qualificationLevel === 2 &&
                            <ApprovePage title="Page Approved. Click to remove approval."/>}
                    </Button>
                )}
                <div
                    onClick={handleClick}
                    onDoubleClick={handleDoubleClick}
                    className={props.dataKey.flyerPageSpots?.length ? styles.grey_icon : ''}
                    data-src={props.dataKey.flyImageThumbnailUrl} data-src-main={props.dataKey.flpImageUrl}>
                    {(props.dataKey.flyImageThumbnailUrl && props.dataKey.flyImageThumbnailUrl!.indexOf('jpg') > 0) ||
                    (props.dataKey.flyImageThumbnailUrl && props.dataKey.flyImageThumbnailUrl!.indexOf('jpeg') > 0) ||
                    (props.dataKey.flyImageThumbnailUrl && props.dataKey.flyImageThumbnailUrl!.indexOf('webp') > 0)
                        ?
                        // <img src={props.dataKey.flyImageThumbnailUrl || ""} alt={""}/>
                        <AsyncPageImage src={props.dataKey.flyImageThumbnailUrl || ""}
                                        pagesDataState={props.pagesDataState}
                                        setPagesDataState={props.setPagesDataState}
                                        dataKey={props.dataKey}
                        />
                        :
                        (isPageHasContent ? <></> : '')
                    }
                </div>
                <div
                    className={`${styles.page_footer} ${props.isActivePage ? styles.is_active_page : ''} ${flyerDetailsState.flyFstRec.fstCaption === "Published" ? styles.disabled : ''}`}>
                    {(props.isActivePage) &&
                        <Box>
                            <LabelFileSelector
                                multiple={false}
                                accept={".jpg, application/pdf"}
                                fileId={props.dataKey.flpRecId!.toString()}
                                onChange={onChangeOnlyOne}
                                onClick={onClick}
                            >
                                <UploadIcon/>
                            </LabelFileSelector>
                        </Box>
                    }
                    <div style={{userSelect: 'none'}}>
                        Page {props.dataKey.flpPageNo}
                    </div>


                    {props.isActivePage &&
                        <Box
                            sx={{
                                // position: "absolute",
                                // top: "50%",
                                // transform: "translateY(-50%)",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                width: "32px",
                                // right: "0px",
                            }}
                        >
                            <Button
                                sx={{
                                    width: "20px",
                                    height: "20px",
                                    "&:disabled": {
                                        opacity: "0.5"
                                    }
                                }}
                                disabled={isUserViewer}
                                // disableRipple={true}
                                ref={anchorRefForPageMenu}
                                aria-controls={
                                    prevOpenPageMenu
                                        ? "menu-list-grow"
                                        : undefined
                                }
                                aria-haspopup="true"
                                onClick={handleToggleForPage}

                            >
                                <MenuOnHover style={{pointerEvents: "none"}}/>
                            </Button>
                            <MenuForPromotion
                                list={clickMenuDataForFlyer}
                                // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                                infoForMenu={`menuForPage`}
                                isDisabledContextMenuOption={isDisabledContextMenuOption}
                                selectedPageRange={props.pagesDataState.selectedPages.length}
                                pageNumber={props.dataKey.flpPageNo}
                                insertAfterPageCallback={insertAfterPageCallback}
                                insertBeforePageCallback={insertBeforePageCallback}
                                optionForSelectPages={optionForSelectPages}
                                deletePages={props.deleteImagesFromPages}
                                movePageCallback={props.movePageCallback}
                                pageId={props.dataKey.flpRecId}
                                onChangePageNUmber={onChange}
                                totalPagesInFlyer={props.pagesDataState.pagesFlyer.length}
                                isShowInfoForPage={isShowInfoForPage}
                                pageWxH={pageWxH}
                            />
                        </Box>
                    }
                </div>
            </div>
        </Grid>
    )
}
